import Giva121 from '../Giva 12/Giva 12 (1).webp'
import Giva122 from '../Giva 12/Giva 12 (2).webp'
import Giva123 from '../Giva 12/Giva 12 (3).webp'
import Giva124 from '../Giva 12/Giva 12 (4).webp'
import Giva125 from '../Giva 12/Giva 12 (5).webp'
import Giva126 from '../Giva 12/Giva 12 (6).webp'
import Giva127 from '../Giva 12/Giva 12 (7).webp'
import Giva128 from '../Giva 12/Giva 12 (8).webp'
import Giva129 from '../Giva 12/Giva 12 (9).webp'
import Giva1210 from '../Giva 12/Giva 12 (10).webp'
import Giva1211 from '../Giva 12/Giva 12 (11).webp'
import Giva1212 from '../Giva 12/Giva 12 (12).webp'


const Giva12images =[
    Giva121,Giva122,Giva123,Giva124,Giva125,Giva126,Giva127,Giva128,Giva129,Giva1210,Giva1211,Giva1212
]

export default Giva12images;